/**
 * Stealth-granting abilities → their stealth window (ms).
 *
 * The server's authority (stealthGuard: mobs, bots and PvP skip a stealthed
 * player) and the client's presentation (StealthVeil: the rogue visibly
 * fades) read this one table — moved here from src/server/combat/stealthGuard
 * by plan 29 lane BY so both sides cannot drift. Server-side only in effect:
 * a client never sends a duration.
 */
export const STEALTH_ABILITIES: Readonly<Record<string, number>> = {
  // Rogue
  vanish: 3000,
  dark_sight: 20000,
  shadow_dance: 8000,
  // Hunter
  camouflage: 8000,
};

/** The stealth duration (ms) for an ability, or 0 if it doesn't grant stealth. */
export function stealthDurationForAbility(abilityId: string): number {
  return STEALTH_ABILITIES[abilityId] ?? 0;
}
